<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 정기구매 철회</h2>
      <ul class="rew19_basketAdd_exp">
        <li>나의 정기구매를 철회하시면 정기구매 주문번호가 삭제되어 지금까지 진행해온 회차별 할인 적용이 모두 사라집니다.</li>

        <li>
<!--          <span v-if="viewData.USPAN_YN == 'Y'" class="rew19_point">3</span>
          <span v-if="viewData.META_YN == 'Y'" class="rew19_point">3</span>
          <span v-if="viewData.USPAN_YN != 'Y' && viewData.META_YN != 'Y'" class="rew19_point">3</span>-->
          <span class="rew19_point">제품 별 약정기간 이전에 철회</span>
          한 회원님은 그간 할인 받으신 금액을 재결제 후 철회가 진행됩니다.
        </li>
      </ul>
      <h3 class="rew19_third_title">세부 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>수령인</em>
          <span class="substance">{{viewData.ship_name}}</span>
        </li>
        <li class="type1">
          <em>전화 번호</em>
          <span class="substance">{{viewData.ship_tel}}</span>
        </li>
        <li class="type1">
          <em>핸드폰 번호</em>
          <span class="substance">{{viewData.ship_phone}}</span>
        </li>
        <li class="type1">
          <em>결제정보</em>
          <span
              v-if='$nvl(viewData.payment_typ,"") == AroConst.VALUE_payment_type_credit_card'
              class="substance">{{viewData.payment_info}}
              <span>{{viewData.inst_month == '00' ? '일시불' : viewData.inst_month + '개월'}}</span></span>
          <span
              v-if='$nvl(viewData.payment_typ,"") == AroConst.VALUE_payment_type_account_transfer'
              class="substance">{{$getContentPaymentType(viewData.payment_typ)}} ({{viewData.print_bank_account}})</span>
        </li>
        <li class="type1">
          <em>배송주소</em>
          <span class="substance">{{viewData.home_addr}} {{viewData.home_addr_detail}}</span>
        </li>
        <li class="type1" v-if="paymentCase != '3' && paymentCase != '4'">
          <em>배송일</em>
          <span class="substance">매월 {{viewData.delivery_day}}일 (시작 월 : {{viewData.delivery_date}})</span>
        </li>
        <li class="type1">
          <em>신청일</em>
          <span class="substance">{{viewData.regdate}}</span>
        </li>
        <li class="type1">
          <em>결제일</em>
          <span class="substance">매월 {{viewData.pay_day}}일</span>
        </li>
        <li class="type1">
          <em>현재 유지 개월</em>
          <span class="substance">{{viewData.payment_count}}개월</span>
        </li>
      </ul>

      <dl class="rew19_backInfo" v-if="viewData.USPAN_YN == 'Y'">
        <dt>
          <span>정기구매 스페셜 멤버십 철회금 산정 기준 안내</span>
        </dt>
        <dd class="rew19_infoStar">스마트 뷰티 스타터 프로그램: 약정 기간(6개월) 이전 철회 시 , 스마트 뷰티 디바이스 잔존 금액(회원가에서 기 납입한 금액 제외) 및 전용 제품의 할인 금액을 모두 반환해야 합니다. </dd>
        <dd class="rew19_infoStar">파마넥스 15% 약정 프로그램 및 스마트 뷰티 플러스 프로그램: 약정 기간(3개월) 이전 철회 시 이전까지 받으신 할인 혜택에 대해 반환해야 합니다.</dd>
      </dl>

      <dl class="rew19_backInfo" v-if="viewData.META_YN == 'Y'">
        <dt>
          <span>정기구매 스페셜 멤버십 철회금 산정 기준 안내</span>
        </dt>
        <dd class="rew19_infoStar">스마트 뷰티 스타터 프로그램: 약정 기간(6개월) 이전 철회 시 , 스마트 뷰티 디바이스 잔존 금액(회원가에서 기 납입한 금액 제외) 및 전용 제품의 할인 금액을 모두 반환해야 합니다. </dd>
        <dd class="rew19_infoStar">파마넥스 15% 약정 프로그램 및 스마트 뷰티 플러스 프로그램: 약정 기간(3개월) 이전 철회 시 이전까지 받으신 할인 혜택에 대해 반환해야 합니다.</dd>
      </dl>

      <h3 class="rew19_third_title">주문 상품</h3>
      <div class="rew19_payment_content" v-for="(pd) in viewData.pd_list" :key="pd.pd_id">
        <div class="rew19_flex_box">
          <div class="rew19_payment_list__img">
            <img :src="pd.pd_img_url1" alt title
                 onError="imageError(this)" data-error-cnt="0"
            />
          </div>

          <div class="rew19_payment_list__infor">
            <h4>{{pd.pd_name_kr}}</h4>
            <ul class="rew19_payment_items flex">
              <li>
                <span class="rew19_point rew19_gDetail">{{$fmt.WON(pd.pd_amt)}} 원 / {{pd.pd_count}}개</span>
              </li>
              <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                <span class="rew19_gDetail">
                  <em>SV</em> {{$fmt.PV(pd.pv)}}
                </span>
              </li>
              <li v-if="getMemberType() == 'DIST'">
                <span class="rew19_gDetail">
                  <em>CSV</em> {{$fmt.PV(pd.cv)}}
                </span>
              </li>
<!--              <li v-if="getMemberType() == 'DIST'">-->
<!--                <span class="rew19_gDetail">-->
<!--                  <em>SB</em> {{$fmt.PV(pd.sb)}}-->
<!--                </span>-->
<!--              </li>-->
              <li>
                <span class="rew19_gDetail">
                  <em>합계</em> {{$fmt.WON(pd.total_amt)}} 원
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="rew19_payment_bottom">
        <ul class="rew19_payList">
          <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
            <em class="rew19_payTitle">합계 SV</em>
            <span class="rew19_payDetail">{{$fmt.PV(viewData.total_pv)}}</span>
          </li>
          <li v-if="getMemberType() == 'DIST'">
            <em class="rew19_payTitle">합계 CSV</em>
            <span class="rew19_payDetail">{{$fmt.PV(viewData.total_cv)}}</span>
          </li>
<!--          <li v-if="isShowTotalSb">-->
<!--            <em class="rew19_payTitle">합계 SB</em>-->
<!--            <span class="rew19_payDetail">{{$fmt.PV(viewData.total_sb)}}</span>-->
<!--          </li>-->
          <li v-bind:class="{lastLine : getMemberType() == 'DIST'}">
            <em class="rew19_payTitle">주문금액</em>
            <span class="rew19_payDetail rew19_point">
              <strong>{{$fmt.WON(viewData.payment_amt)}} 원</strong>
            </span>
          </li>
          <li class="lastLine">
            <em class="rew19_payTitle" v-if="viewData.USPAN_YN == 'Y'">
              정기구매 철회 위약금
              <br />약정 기간 이전 철회 시, 지금까지 할인 받은 금액
            </em>
            <em class="rew19_payTitle" v-if="viewData.META_YN == 'Y'">
              정기구매 철회 위약금
              <br />약정 기간 이전 철회 시, 지금까지 할인 받은 금액
            </em>
            <em class="rew19_payTitle" v-if="viewData.USPAN_YN != 'Y' && viewData.META_YN != 'Y'">
              정기구매 철회 위약금
              <br />약정 기간 이전 철회 시, 지금까지 할인 받은 금액
            </em>
            <span class="rew19_payDetail rew19_point">
              <strong>{{$fmt.WON(viewData.cancel_amt)}} 원</strong>
            </span>
          </li>
        </ul>
      </div>

      <div class="rew19_responsive_btns gepTaye1">
        <a @click="openAroCancelDialog" class="rew19-btn-normal">정기구매 취소 정산내역 상세보기</a>
      </div>

      <div class="rew19_responsive_btns gepTaye1">
        <a @click="onClickCancel" class="rew19-btn-border">취소</a>
        <a v-if="viewData.cancel_amt <= 0"
          @click="onClickWithdraw" class="rew19-btn-normal">철회하기</a>
        <a v-else
          @click="onClickNextProcess" class="rew19-btn-normal">다음</a>

      </div>
    </div>
    <!--rew19_contents_inner-->

    <aro-cancel-dialog
      :show="aroCancelDialogShow"
      @close="onCloseAroCancelDialog"
      ref="aroCancelDialog"
    ></aro-cancel-dialog>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import AroCancelDialog from '@/components/popup/AroCancelDialog';

export default {
  name: "AroCancel",
  extends: AroBase,
  components: {AroCancelDialog},
  computed: {
    isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    }
  },
  props:{
    aro_no: {
      type: String,
      required: true
    },
    paymentCase : {
      type: String,
      required: true
    }
  },
  data() {
    return {
      //View Data
      viewData : {

      },

      aroCancelDialogShow : false,
      aroCancelDialog : {},
      // isShowTotalSb : false,

    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    // if(_this.getMemberType() == "DIST" && _this.getMemberTitle() >= 40){
    //   _this.isShowTotalSb = true;
    // }
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI(){

    },

    initData(paramData){
      let _this = this;

      _this.viewData = {
        ...paramData
      };
    },

    //취소
    onClickCancel(){
      this.$emit('cancel');
    },


    //정기구매 취소 정산내역
    openAroCancelDialog(){
      let _this = this;

      //pass data to dialog
      _this.aroCancelDialog = {
        regdate : _this.viewData.regdate,
        payment_count: _this.viewData.payment_count,
        saving_percentage : _this.viewData.saving_percentage,
        pd_list : _this.viewData.pd_list,
        cancel_amt : _this.viewData.cancel_amt
      };

      _this.$refs.aroCancelDialog.initData(_this.aroCancelDialog);
      _this.aroCancelDialogShow = true;
    },

    onCloseAroCancelDialog(data, isOk) {
      let _this = this;
      _this.aroCancelDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }
    },

    //철회 하기
    onClickWithdraw(){
      let _this = this;

      let payment_type = _this.viewData.payment_typ;
      let additionalData = {};
      if(_this.AroConst.VALUE_payment_type_credit_card == payment_type){
        additionalData = {
          ccard_no : _this.viewData.ccard_no,
          ccard_exp : _this.viewData.ccard_exp
        };

        additionalData = _this.processEncodeOrNot(additionalData, _this.viewData);

      }else if(_this.AroConst.VALUE_payment_type_account_transfer == payment_type){
        additionalData = {}; //추가데이터 없음
      }else{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        return;
      }

      _this.$emit('doWithdraw', payment_type, additionalData);
    },

    //다음 진행
    onClickNextProcess(){
      this.$emit('nextProcess');
    },
    processEncodeOrNot(paramData, viewData) {
      let _this = this;

      let keys = Object.keys(paramData);
      for(let i=0; i<keys.length; i++) {

        let jsonKey = keys[i];
        let value = '';

        if (jsonKey === 'ccard_no') {
          /* 암호화 여부를 카드번호 length 와  integration 복호화 키 여부로 체크  */
          if (paramData.ccard_no.length > 16 && !viewData.integration) {
            value = GibberishAES.aesDecrypt(paramData.ccard_no, _this.getMemberId() + viewData.integration);
          } else {
            value = paramData.ccard_no;
          }
          paramData[jsonKey] = GibberishAES.aesEncrypt(value, _this.$getMemberIdKey());
        }

        if (jsonKey === 'ccard_exp') {
          if (paramData.ccard_exp.length > 6 && !viewData.integration) {
            value = GibberishAES.aesDecrypt(paramData.ccard_exp, _this.getMemberId() + viewData.integration)
          } else {
            value = paramData.ccard_exp;
          }
          paramData[jsonKey] = GibberishAES.aesEncrypt(value, _this.$getMemberIdKey());
        }

      }
      return paramData;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/my/aro/cancelInfo.vue